import { useParams } from 'react-router-dom'

export const useTeamleadId = (): string | undefined => {
  const { teamleadId } = useParams()
  if (!teamleadId) {
    return undefined
  }
  return teamleadId
}
